








































import { listFactory } from '@/main/pages';
import _ from 'lodash';
import { ServiceJobsDropDownListItem } from '@/main/store/@types/dropdown.d';
import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, validateDateFields, getCurrentLanguageId } from '@/main/utils/commonFunctions';

import { getColumnsNames } from '@/main/utils/table';

import { NAME, PART_SALES_ORDER_TYPE } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';
import { array } from '@storybook/addon-knobs';

export default listFactory(NAME, store).extend({
	data() {
		return {
			validateMessage: '',
			revenueDetailsParams: 'null' as string,
			fromDate: 'fromDate',
			toDate: 'toDate',
			isPartSales: false as boolean,
		};
	},

	methods: {
		async filterClick() {
			if(this.OrderType.length==0){
				this.showErrorAlert({ message: this.LocalizePopisPoli('ORDER_TYPE_REQUIRED') });
				return;
			}
			if (!this.DateFrom) {
				this.showErrorAlert({ message: this.LocalizePopisPoli('DP_DATEFROM_VALIDATION') });
				return;
			}
			if (!this.DateTo) {
				this.showErrorAlert({ message: this.LocalizePopisPoli('DP_DATETO_VALIDATION') });
				return;
			}
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.WorkshopId,
				(columnsSeq) => ({
					DateFrom: new Date(this.DateFrom!).toISOString(),
					DateTo: new Date(this.DateTo!).toISOString(),
					PracovnikId: this.loggedUser.UzivatelData.PracovnikId,
					OrderType: this.OrderType,
					WorkshopId: this.WorkshopId,
					Brand: this.Brand,
					ColumnSequence: getColumnsNames(this.table.columns.filter(x => x.isVisible === true)).join(','),
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
				}),
			);
		},
		/**
		 * Updates the state related to service jobs.
		 * - Sets `isPartSales` to true if `OrderType` includes 'B' (Part Sales Order), indicating a part sales order.
		 * - If it is a part sales order, resets `VyrobekvozOzn` to an empty string.
		 */
		serviceJobsUpdate() {
			this.isPartSales = this.OrderType.includes(PART_SALES_ORDER_TYPE);
			if (this.isPartSales) this.Brand = '';
		},
		dealerLocationUpdate() {
			const result = {} as any;
			this.dropdownList.WorkshopId.forEach((o: any) => {
				result[o.Value] = o.Text;
			});
		},

		async onDealerLocationChange(workshopId: number) {
			if (!_.isUndefined(workshopId)) {
				this.dropdownList.FilteredServiceJobs = this.dropdownList.ServiceJobs.filter((job: ServiceJobsDropDownListItem) => job.WorkshopId === workshopId);
			} else {
				this.dropdownList.FilteredServiceJobs = [];
			}
		},

		async exportReportbyServiceJob() {
			if (!this.ServiceJobs || this.ServiceJobs.length === 0) {
				this.showErrorAlert({ message: this.LocalizePopisPoli('SERVICE_JOBS_REQUIRED') });
				return;
			}
			let parameters = '';
				if (this.WorkshopId.length > 0) {
				this.WorkshopId.forEach((WorkshopId: any) => {
					parameters = parameters.concat(`&WorkshopId=${WorkshopId}`);
				});
			}
			this.startLoading();
			await apiProvider.exportReportbyServiceJob(new Date(this.DateFrom!).toISOString(), new Date(this.DateTo!).toISOString(), this.ServiceJobs, parameters);
			this.endLoading();
		},
		dateValidation() {
			if (this.DateFrom && this.DateTo) {
				const fromDate = new Date(this.DateFrom);
				const toDate = new Date(this.DateTo);
				if (fromDate > toDate) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DP_FROM_DATE_LESS_THAN_TO_DATE') });
					this.DateFrom = null;
					this.DateTo = null;
					return false;
				}
				const milisecondPerDay = 1000 * 60 * 60 * 24;

				const utc1 = Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
				const utc2 = Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
				const dayDifference = Math.floor((utc2 - utc1) / milisecondPerDay);
				if (dayDifference > 90) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DP_90_DAY_DIFF') });
					this.DateFrom = null;
					this.DateTo = null;
					return false;
				}
				return true;
			}
			return false;
		},

		validation(WorkshopId: any, DateFrom: any, DateTo: any, OrderType: any, Brand: any) {
			this.revenueDetailsParams = `dateFrom=${DateFrom}&dateTo=${DateTo}`;
			if (this.WorkshopId.length > 0) {
				this.WorkshopId.forEach((WorkshopId: any) => {
					this.revenueDetailsParams = this.revenueDetailsParams.concat(`&WorkshopId=${WorkshopId}`);
				});
			}
			if (OrderType.length > 0) {
				OrderType.forEach((o: any) => {
					this.revenueDetailsParams = this.revenueDetailsParams.concat(`&orderType=${o}`);
				});
			} else {
				this.revenueDetailsParams = OrderType;
			}
			if (Brand?.length > 0) {
				Brand.forEach((brand: any) => {
					this.revenueDetailsParams = this.revenueDetailsParams.concat(`&Brand=${brand}`);
				});
			}
			return this.revenueDetailsParams;
		},

		async exportFun() {
			try {
				if (this.filter.WorkshopId == null || this.filter.WorkshopId.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
				if (!this.WorkshopId || !this.DateFrom || !this.DateTo || !this.OrderType) {
					return;
				}
				const getColumnsSequence = getColumnsNames(this.table.columns.filter(x => x.isVisible === true));
				this.startLoading();
				const params = this.validation(this.WorkshopId, new Date(this.DateFrom!).toISOString(), new Date(this.DateTo!).toISOString(), this.OrderType, this.Brand);
				if (this.isMultipleWorkshopSelected) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
					});
				} else {await apiProvider.GetRevenueDetailsReport(params, getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId), getColumnsSequence);
				}
				this.endLoading();
			} catch (error) {
				this.endLoading();
			}
		},
	},
	computed: {
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.WorkshopId);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.WorkshopId);
		},
	},
	watch: {
		'dropdownList.OrderType': {
			handler(neworderTypes) {
				if (neworderTypes?.length > 0) {
					const orderTypes: { Disabled: boolean; Label: string | null; Text: string;	Value: string; }[] = this.dropdownList.OrderType.map(s => s);
					this.OrderType = orderTypes.map(s => s.Value);
				}
				// Checks if 'OrderType' is an array and contains the value 'Part Sales'.
				// If true, sets 'isPartSales' to true, indicating that the order includes part sales.
				// Use constant for Part Sales Order type
				if (Array.isArray(this.OrderType) && this.OrderType.includes(PART_SALES_ORDER_TYPE)) {
					this.isPartSales = true;
				}
			},
		},
	},
	mounted() {
		const element = document.getElementsByClassName('el-main');
		if (element.length !== 0) element[0].classList.remove('d-flex');
	},
});
